var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4195 7.5073C12.9314 7.5073 13.3463 7.09235 13.3463 6.58047C13.3463 6.0686 12.9314 5.65364 12.4195 5.65364C11.9076 5.65364 11.4927 6.0686 11.4927 6.58047C11.4927 7.09235 11.9076 7.5073 12.4195 7.5073Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3399 4.58779C15.8518 4.58779 16.2667 4.17284 16.2667 3.66096C16.2667 3.14909 15.8518 2.73413 15.3399 2.73413C14.828 2.73413 14.413 3.14909 14.413 3.66096C14.413 4.17284 14.828 4.58779 15.3399 4.58779Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0758 7.23587L15.9953 4.31635L14.6845 3.00562L11.765 5.92514L13.0758 7.23587Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58072 7.5073C7.0926 7.5073 7.50755 7.09235 7.50755 6.58047C7.50755 6.0686 7.0926 5.65364 6.58072 5.65364C6.06885 5.65364 5.65389 6.0686 5.65389 6.58047C5.65389 7.09235 6.06885 7.5073 6.58072 7.5073Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66034 4.58779C4.17221 4.58779 4.58717 4.17284 4.58717 3.66096C4.58717 3.14909 4.17221 2.73413 3.66034 2.73413C3.14847 2.73413 2.73351 3.14909 2.73351 3.66096C2.73351 4.17284 3.14847 4.58779 3.66034 4.58779Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23612 5.92514L4.3166 3.00562L3.00587 4.31635L5.92538 7.23587L7.23612 5.92514Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58072 13.3463C7.0926 13.3463 7.50755 12.9314 7.50755 12.4195C7.50755 11.9076 7.0926 11.4927 6.58072 11.4927C6.06885 11.4927 5.65389 11.9076 5.65389 12.4195C5.65389 12.9314 6.06885 13.3463 6.58072 13.3463Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66034 16.2658C4.17221 16.2658 4.58717 15.8509 4.58717 15.339C4.58717 14.8271 4.17221 14.4122 3.66034 14.4122C3.14847 14.4122 2.73351 14.8271 2.73351 15.339C2.73351 15.8509 3.14847 16.2658 3.66034 16.2658Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92538 11.7642L3.00587 14.6837L4.3166 15.9944L7.23612 13.0749L5.92538 11.7642Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4195 13.3463C12.9314 13.3463 13.3463 12.9314 13.3463 12.4195C13.3463 11.9076 12.9314 11.4927 12.4195 11.4927C11.9076 11.4927 11.4927 11.9076 11.4927 12.4195C11.4927 12.9314 11.9076 13.3463 12.4195 13.3463Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3399 16.2658C15.8518 16.2658 16.2667 15.8509 16.2667 15.339C16.2667 14.8271 15.8518 14.4122 15.3399 14.4122C14.828 14.4122 14.413 14.8271 14.413 15.339C14.413 15.8509 14.828 16.2658 15.3399 16.2658Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.765 13.0749L14.6845 15.9944L15.9953 14.6837L13.0758 11.7642L11.765 13.0749Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49912 10.4268C10.011 10.4268 10.4259 10.0119 10.4259 9.49999C10.4259 8.98811 10.011 8.57315 9.49912 8.57315C8.98724 8.57315 8.57228 8.98811 8.57228 9.49999C8.57228 10.0119 8.98724 10.4268 9.49912 10.4268Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5011 10.4268C10.013 10.4268 10.4279 10.0119 10.4279 9.49999C10.4279 8.98811 10.013 8.57315 9.5011 8.57315C8.98923 8.57315 8.57427 8.98811 8.57427 9.49999C8.57427 10.0119 8.98923 10.4268 9.5011 10.4268Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58072 7.5073C7.0926 7.5073 7.50755 7.09235 7.50755 6.58047C7.50755 6.0686 7.0926 5.65364 6.58072 5.65364C6.06885 5.65364 5.65389 6.0686 5.65389 6.58047C5.65389 7.09235 6.06885 7.5073 6.58072 7.5073Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1565 8.84465L7.23698 5.92513L5.92625 7.23587L8.84577 10.1554L10.1565 8.84465Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4195 13.3463C12.9314 13.3463 13.3463 12.9314 13.3463 12.4195C13.3463 11.9076 12.9314 11.4927 12.4195 11.4927C11.9076 11.4927 11.4927 11.9076 11.4927 12.4195C11.4927 12.9314 11.9076 13.3463 12.4195 13.3463Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49912 10.4268C10.011 10.4268 10.4259 10.0119 10.4259 9.49999C10.4259 8.98811 10.011 8.57315 9.49912 8.57315C8.98724 8.57315 8.57228 8.98811 8.57228 9.49999C8.57228 10.0119 8.98724 10.4268 9.49912 10.4268Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0749 11.7642L10.1554 8.84464L8.84464 10.1554L11.7642 13.0749L13.0749 11.7642Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.1392cb57844b35206e97c334499e7ff8.svg";
export { ForwardRef as ReactComponent };